export default __webpack_public_path__ + "static/media/frnds.ba295f4b.png";